module.exports = __webpack_public_path__ + "static/media/dpl-icon.4460dce9.png";